import { api_GET, api_POST, } from "api/_axios.js";

const dashboardbi_api =
{
    getSegmentosbyRegionais: function (regionais) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DashboardBI/GetSegmentosbyRegionais`, regionais).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getGruposEconomicosbyRegionaisSegmentos: function (json_filtros) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DashboardBI/GetGruposEconomicosbyRegionaisSegmentos`, json_filtros).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getLojasbyGruposERegionais: function (json_filtros) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DashboardBI/GetLojasByRegionaisEGrupos`, json_filtros).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getMesAnoDreMensal: function (lojas) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DashboardBI/GetMesAnoDisponiveis`, lojas).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getDadosGraficosBI: function (json_filtros) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DashboardBI/GetDadosDashboardBI`, json_filtros).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getDadosDashboard13M: function (json_filtros) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DashboardBI/GetDadosDashboard13M`, json_filtros).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getDadosDetalhadoGraficosBI: function (json_filtros) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DashboardBI/GetDadosGrupoLojaDashboardBI`, json_filtros).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default dashboardbi_api
